'use client';

import { WithAuth } from "@/context/authentication";

export function Providers({ children }: { children: React.ReactNode }) {
    return <WithAuth>{children}</WithAuth>;
}